import RouterAutoCheckin from "./routes/routes";

const AutocheckinContainer = ({match}) => { 
    return (
        <RouterAutoCheckin match={match}/>
    )
}

export default AutocheckinContainer;